import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { axiosput } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import { Form, Formik } from "formik";
import ms_applicant from "../../validators/ms_applicant";
import ErrorMessage from "../../components/ErrorMessage";
import useAuthStore from "../../stores/useAuthStore";

const Forgot = () => {
  const navigate = useNavigate();
  const { settings } = useAuthStore();

  const _recover = async (values) => {
    try {
      const uname = values.emailaddress;
      const req = await axiosput("ms_applicant/forgot", {
        emailaddress: uname,
      });
      if (req.status !== 200) {
        throw new Error("Sorry, system could not finish processing your request");
      }
      const { type, message } = req.data;
      if (type === "success") {
        swal(type, message);
        setTimeout(() => navigate("/"), 1000);
      } else {
        swal(type, message);
      }
    } catch ({ message }) {
      swal("warning", message);
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-50 font-sans">
      {/* Image Section */}
      <div
        className="hidden lg:flex lg:flex-[0_0_65%] flex-col justify-center items-center text-white p-10 text-center"
        style={{
          background: "linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url('/images/classroom.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-5xl font-extrabold mb-5">{settings?.institutionName || settings?.shortName || "ATBCOE Kangere"}</h1>
        <p className="text-lg opacity-90">Recover your account password to regain access to the portal.</p>
      </div>
      {/* Form Section */}
      <div className="flex flex-col justify-center items-center p-10 bg-white shadow-[-10px_0_30px_rgba(0,0,0,0.05)] flex-[0_0_35%] max-lg:flex-[0_0_100%]">
        <div className="flex justify-center mb-8 mt-16">
          <img src={settings?.logo || "/images/college-logo.png"} alt="Institution Logo" className="h-20" onError={(e) => { e.target.onerror = null; e.target.src = "/images/college-logo.png"; }} />
        </div>
        <div className="text-center mb-4">
          <h4 style={{ fontWeight: 700 }}>RECOVER PASSWORD</h4>
          <p className="text-muted">Enter your email address to reset your password</p>
        </div>
        <div className="w-full max-w-[400px]">
          <Formik
            initialValues={{ emailaddress: "" }}
            validationSchema={ms_applicant.forgetpasswordrules}
            onSubmit={_recover}
          >
            {({ isSubmitting, touched, errors }) => (
              <Form>
                <div className="mb-4">
                  <ErrorMessage name="emailaddress" label="Email Address" errors={errors?.emailaddress} touched={touched?.emailaddress} />
                </div>
                <button type="submit" disabled={isSubmitting} className="btn btn-primary w-100 py-3 font-weight-bold">
                  {isSubmitting ? "Please wait..." : "Recover Password"}
                </button>
                <div className="mt-4 text-center">
                  <Link to="/" className="text-decoration-none font-weight-bold">Back to Login</Link>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default Forgot;
